import React, { useState } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import { useSelector, useDispatch } from 'react-redux'
import { Input, Button, Picker } from '../root/components/common'
import { verifyTwoFactorRequest, logout, setLocale } from '../root/actions'
import { Fade, Typography } from '@material-ui/core'
import { LOCALE_DISPLAY_OPTIONS } from '../root/constants'

const useStyles = makeStyles(theme => ({
    wrapper: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.background,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative'
    },
    langPickerWrapper: {
        position: 'absolute',
        top: 20,
        right: 20
    },
    formWrapper: {
        width: 600,
        '@media (max-width: 767px)': {
            width: '90%'
        },
        '@media (max-width: 320px)': {
            width: '100%'
        }
    },
    loginLogo: {
        backgroundImage: `url("${theme.loginLogo}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        width: 600,
        height: 200,
        marginBottom: 15,
        '@media (max-width: 767px)': {
            width: '90%'
        },
        '@media (max-width: 320px)': {
            width: '100%'
        }
    },
    heading: {
        fontWeight: 'bold',
        fontSize: 20,
        marginBottom: 8,
        color: theme.textPrimary
    },
    helperText: {
        fontSize: 13,
        color: theme.textSecondary,
        marginBottom: 20
    },
    input: {
        marginBottom: 15
    },
    actionWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 15
    },
    backWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    link: {
        fontWeight: 'bold',
        color: theme.primary,
        cursor: 'pointer',
        fontSize: 12
    }
}))

function TwoFactor(props) {
    const classes = useStyles()
    const dispatch = useDispatch()

    const { token, twoFactorToken, locale, localeCode, isLoading } =
        useSelector(state => state.main)

    const [code, setCode] = useState('')

    const isCodeComplete = code.length === 6

    const handleVerify = () => {
        if (!isCodeComplete || isLoading) return
        dispatch(verifyTwoFactorRequest({ twoFactorToken, code }))
    }

    const handleBack = () => {
        dispatch(logout())
        props.history.push('/login')
    }

    const onLanguageSelect = code => {
        dispatch(setLocale(code))
    }

    if (!twoFactorToken) {
        return <Redirect to={{ pathname: '/login' }} />
    }

    if (token) {
        return <Redirect to={{ pathname: '/dashboard' }} />
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes.langPickerWrapper}>
                <Picker
                    onChange={onLanguageSelect}
                    value={localeCode}
                    options={LOCALE_DISPLAY_OPTIONS}
                />
            </div>
            <Fade in={true} timeout={500}>
                <div className={classes.formWrapper}>
                    <div className={classes.loginLogo}></div>
                    <Typography className={classes.heading}>
                        {locale.twoFactor.title}
                    </Typography>
                    <Typography className={classes.helperText}>
                        {locale.twoFactor.helperText}
                    </Typography>
                    <Input
                        autoFocus
                        className={classes.input}
                        label={locale.common.confirmationCode}
                        type="text"
                        setValue={val => {
                            const numeric = val.replace(/\D/g, '').slice(0, 6)
                            setCode(numeric)
                        }}
                        onEnter={handleVerify}
                        value={code}
                        inputProps={{ maxLength: 6, inputMode: 'numeric' }}
                    />
                    <div className={classes.actionWrapper}>
                        <Button
                            onClick={handleVerify}
                            disabled={!isCodeComplete || isLoading}>
                            {locale.twoFactor.verify}
                        </Button>
                    </div>
                    <div className={classes.backWrapper}>
                        <div onClick={handleBack} className={classes.link}>
                            {locale.twoFactor.backToLogin}
                        </div>
                    </div>
                </div>
            </Fade>
        </div>
    )
}

export default withRouter(TwoFactor)
